import Vue from "vue";

export async function show(token) {
  const response = await Vue.prototype.$http.get(`e/simple-fnol/${token}`);

  return response.data;
}

export async function save(token, payload) {
  const response = await Vue.prototype.$http.post(
    `e/simple-fnol/${token}`,
    payload
  );

  return response.data;
}

export async function finish(token, payload) {
  const response = await Vue.prototype.$http.post(
    `e/simple-fnol/${token}/finish`,
    payload
  );

  return response.data;
}

export async function upload(token, file, file_type) {
  const form = new FormData();
  form.append("file", file);
  form.append("file_type", file_type);

  const response = await Vue.prototype.$http.post(
    `e/simple-fnol/${token}/files`,
    form
  );

  return response.data;
}

export async function removeFile(token, fileId) {
  const response = await Vue.prototype.$http.delete(
    `e/simple-fnol/${token}/files/${fileId}`
  );

  return response;
}
